var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .836)",
    fill: "#FAA100",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fillOpacity: 0.1,
    cx: 29.987,
    cy: 30,
    rx: 29.987,
    ry: 30
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.41 20.857a8.972 8.972 0 0 0-3.71 2.003v-6.1c0-1.015.831-1.84 1.854-1.84a1.85 1.85 0 0 1 1.856 1.84v4.097zM31.164 40.729v1.62c0 1.058-.865 1.92-1.934 1.92h-2.817a1.932 1.932 0 0 1-1.656-.935l-2.035-.66a7.231 7.231 0 0 1-5.019-6.662 8.878 8.878 0 0 0 4.643 2.216c.013.003.025.003.037.006.4.422.905.75 1.49.939l1.047.34c.354-.429.893-.7 1.493-.7h2.817c1.069-.001 1.934.858 1.934 1.916z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.225 25.464H23.709c-2.316 0-4.261 1.982-3.98 4.454.199 1.746 1.605 3.199 3.344 3.456a4.053 4.053 0 0 0 3.094-.789c2.348-1.813 5.578-1.697 7.875.035a3.993 3.993 0 0 0 2.418.802c2.21 0 4.045-1.79 4.007-4.05-.037-2.155-1.94-3.908-4.242-3.908z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.225 21.78H23.71c-4.578 0-8.192 3.95-7.666 8.551.382 3.375 3.11 6.188 6.48 6.686 2.23.325 4.302-.272 5.921-1.525.952-.734 2.33-.71 3.356.064a7.682 7.682 0 0 0 4.658 1.55c4.32 0 7.79-3.506 7.719-7.796-.07-4.155-3.64-7.53-7.953-7.53zm.234 12.865a5.217 5.217 0 0 1-3.162-1.052c-1.856-1.4-4.47-1.513-6.373-.043a5.26 5.26 0 0 1-4.033 1.034c-2.281-.337-4.126-2.241-4.387-4.528-.364-3.21 2.167-5.815 5.206-5.815h12.515c2.968 0 5.425 2.293 5.475 5.109.049 2.916-2.31 5.295-5.24 5.295z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.57f974e1f1253fc7942135ebd1104e54.svg";
export { ForwardRef as ReactComponent };